import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { policyMappingDescription } from 'src/app/core/models/regulation/policy-Mapping-Description-Model';
import { DescriptionModel, MappedRegulatoryModel, MatchPoliciesModel, PolicyMappingCombinationModel, mappingPolicyModel, policyMappingData } from 'src/app/core/models/regulation/policy-Mapping-model';
import { RegulationService } from 'src/app/core/services/regulation';
import { PolicyMappingDescriptionComponent } from '../policy-mapping-description/policy-mapping-description.component';
import { UserProfile } from 'src/app/core/models/user';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { RegulationModel } from 'src/app/core/models/regulation';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RigSettingsComponent } from '../rig-settings/rig-settings.component';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { GetDocumentDto, UploadResponse, UrlUploadRequest } from 'src/app/core/models/rig-model/file-upload';
import { RigService } from 'src/app/core/services/rig/rig.service';


@Component({
  selector: 'app-change-viewer-rig',
  templateUrl: './change-viewer-rig.component.html',
  styleUrls: ['./change-viewer-rig.component.scss']
})
export class ChangeViewerRigComponent {
  pdfContent: string = '';
  totalPages: number = 0;
  isLoaded: boolean = false;
  page: number = 1;
  zoomLevel: number = 1;
  constructor(
    private regulationService: RegulationService,private userService:UserManagementService,
    private ref: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private rigService: RigService
  ) { }
  @Input() updatedDbId: number = 0;
  @Input() userJurisdiction: Array<ItemIdModel> = [];
  @Input() user: UserProfile | undefined;
  @Input() regulation: RegulationModel = new RegulationModel();
  policyMappingDescription: policyMappingDescription[] = [];
  jurisdictionName: string = "";
  policyMappingData: policyMappingData = new policyMappingData();
  linkedDocumentsArray: Array<string> = [];
  showPdf: boolean = false;
  selectedLinkedDocuments: string[] = [];
  selectedDescriptionId: number[] = [];
  policyText: string = "";
  isShowPolicyText: boolean = false;
  isLoadingPolicy: boolean = false;
  isShowMappedRegulatory: boolean = false;
  isShowTable: boolean = false;
  matchPoliciesInput: MatchPoliciesModel = new MatchPoliciesModel();
  policiesDescriptionModel: DescriptionModel[] = [];
  MappedRegulatory: MappedRegulatoryModel = new MappedRegulatoryModel();
  matchPolicies: mappingPolicyModel[] = [];
  mappingLoading: boolean = false;
  isPolicyDataLoaded = false;
  joseToken:any= [];
  streamlitUrl!: string;
  isLoading = false;

  async ngOnInit() {
    this.mappingLoading = true;
    this.regulationService.GetPolicyMapping(this.updatedDbId).subscribe((data: policyMappingData) => {
      if (data && data?.description) {
        this.policyMappingData = data;
        if (data.description) {
          this.policyMappingDescription = JSON.parse(data.description) as policyMappingDescription[];
        }
        if (data.linkedDocuments) {
          this.linkedDocumentsArray = this.policyMappingData.linkedDocuments.split("|");;
        }
      }
      this.mappingLoading = false;
    });
    this.matchPoliciesInput.updateModel.country = this.regulation.country;
    this.matchPoliciesInput.updateModel.geography = this.regulation.geography;
    this.matchPoliciesInput.updateModel.regulator = this.regulation.regulator;
    this.matchPoliciesInput.updateModel.title = this.regulation.title;
    this.matchPoliciesInput.updateModel.pubDate = this.regulation.date;
    this.matchPoliciesInput.updateModel.pubType = this.regulation.pubType;
    this.matchPoliciesInput.updateModel.hyperlink = this.regulation.hyperlink;
    this.matchPoliciesInput.updateModel.updatesId = this.updatedDbId;
  }

  editButtonClick() {
    let description = "";
    let jurisdictionFilter = this.userJurisdiction.filter(x => x.id == this.user?.lastUsedJurisdictionId);
    if (jurisdictionFilter.length > 0) {
      this.jurisdictionName = jurisdictionFilter[0].name;
      let descriptionFilter = this.policyMappingDescription.filter(x => x.Jurisdiction == this.jurisdictionName);
      if (descriptionFilter.length > 0) {
        description = descriptionFilter[0].Description;
      }
    }
    const dialogRef = this.dialog.open(PolicyMappingDescriptionComponent, {
      width: '1000px',
      data: description
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const existingEntryIndex = this.policyMappingDescription.findIndex(
          entry => entry.Jurisdiction === this.jurisdictionName
        );
        if (existingEntryIndex !== -1) {
          // Update existing entry
          this.policyMappingDescription[existingEntryIndex].Description = result;
        } else {
          // Push new entry
          let ob = new policyMappingDescription();
          const maxId = this.policyMappingDescription.reduce((max, item) => {
            return item.Id > max ? item.Id : max;
          }, 0);
          ob.Id = maxId + 1;
          ob.Jurisdiction = this.jurisdictionName;
          ob.Description = result;
          ob.User = this.user?.fullName;
          this.policyMappingDescription.push(ob);
        }
        this.policyMappingData.description = JSON.stringify(this.policyMappingDescription);
        this.updatePolicyMapping();
      }
    });
  }
  updatePolicyMapping() {
    this.regulationService.UpdatePolicyMapping(this.policyMappingData).subscribe((data: any) => {

    });
  }
  pdfSrc: string | ArrayBuffer | Uint8Array | undefined;
  openPdf(link: string) {
    this.userService.generateJoseJWT("").subscribe((token: any) => {
      const myData = new UrlUploadRequest();
      myData.AzureContainerName = "oceandata";
      myData.ExternalUrl = link;
      this.rigService.getUrlOrFileFetchedData(token.message, myData).subscribe((result: UploadResponse) => {
        const myPdf = new GetDocumentDto();
        myPdf.containerName = "oceandata";
        myPdf.documentName = result.DisplayName;
        this.openDocument(myPdf);
      })
    })
  }
  isDescriptionView: boolean = true;
  isMapDashboardView: boolean = false;
  isPolicyView: boolean = true;
  isDocumentView: boolean = false;
  selectLeftTabIndex: number = 0;
  selectRightTabIndex: number = 0;
  tabMenuChanged(event: any): void {
    if (event.index == 0) {
      this.isPolicyView = true;
      this.isMapDashboardView = false;
    }
    else if (event.index == 1) {
      this.isPolicyView = false;

      this.isMapDashboardView = true;
      this.isLoading = true;
      this.getDashboardReport();
    }
  }
  getDashboardReport(){
    this.userService.generateClusterJoseJWT(this.updatedDbId)
      .subscribe((config: string) => {
        this.joseToken = config;
        this.streamlitUrl = "https://clustering.finrege.com/?key=" + this.joseToken.message;
        this.isLoading = false;
      });
  }
  isPdfLink(link: string): boolean {
    // Case-insensitive check for link ending with ".pdf"
    return link.toLowerCase().endsWith('.pdf');
  }
  addDescription(desc: policyMappingDescription, checked: boolean) {
    if (checked) {
      let descriptionModel = new DescriptionModel();
      descriptionModel.Description = desc.Description;
      descriptionModel.Jurisdiction = desc.Jurisdiction;
      descriptionModel.IsOriginal = desc.IsOriginal;
      descriptionModel.User = desc.User ? desc.User : null;
      this.policiesDescriptionModel.push(descriptionModel);
      this.selectedDescriptionId.push(desc.Id);

    }
    else {
      const index = this.policiesDescriptionModel.findIndex(item => item.Description === desc.Description && item.Jurisdiction === desc.Jurisdiction);
      // If the description is found, remove it from the array
      if (index !== -1) {
        this.policiesDescriptionModel.splice(index, 1);
      }
      const idIndex = this.selectedDescriptionId.findIndex(item => item === desc.Id);
      if (idIndex !== -1) {
        this.selectedDescriptionId.splice(idIndex, 1);
      }
    }
    this.matchPoliciesInput.descriptionModel = this.policiesDescriptionModel;
  }
  addLinkedDocuments(link: string, checked: boolean) {
    if (checked) {
      this.selectedLinkedDocuments.push(link);
    }
    else {
      this.selectedLinkedDocuments = this.selectedLinkedDocuments.filter(x => x != link);
    }
    this.matchPoliciesInput.linkedDocuments = this.selectedLinkedDocuments.join('|');
  }
  getMapData() {
    this.mappingLoading = true;
    this.isShowPolicyText = false;
    this.policyText = "";
    this.matchPoliciesInput.descriptionModel = this.policiesDescriptionModel;
    let combination = new PolicyMappingCombinationModel();
    combination.descriptionsIds = this.selectedDescriptionId;
    combination.links = this.selectedLinkedDocuments;
    this.regulationService.getMappedData(this.matchPoliciesInput, combination).subscribe(
      (data: mappingPolicyModel[]) => {
        this.matchPolicies = data;
        this.isShowTable = true;
        this.isShowMappedRegulatory = true;
        this.mappingLoading = false;
        this.selectRightTabIndex = 0;
      })
  }
  GetPolicies(policyName: string) {
    this.isLoadingPolicy = true;
    this.isPolicyDataLoaded = true;
    this.ref.detectChanges();
    this.regulationService.GetPolicies(policyName).subscribe((data: any) => {
      this.policyText = data.polices;
      this.isShowPolicyText = true;
      this.isLoadingPolicy = false;
    });
  }

  leftTabMenuChanged(event: any): void {
    if (event.index == 0) {
      this.isDescriptionView = true;
      this.isDocumentView = false;
    }
    else if (event.index == 1) {
      this.isDescriptionView = false;
      this.isDocumentView = true;
    }
  }

  getTooltipContent(suggestedName: string, source: string, page: string): any {
    const htmlContent = `
      <table>
        <thead>
          <tr>
            <th>Suggest Name</th>
            <th>Source</th>
            <th>Page</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${suggestedName}</td>
            <td>${source}</td>
            <td>${page}</td>
          </tr>
        </tbody>
      </table>
    `;
    const newString = `Suggest Name : ${suggestedName}\nSource : ${source}\nPage : ${page}
    `;

    const suggestedNameLine = `(Suggest Name) : ${suggestedName}`;
    const sourceLine = `(Source) : ${source}`;
    const pageLine = `(Page) : ${page}`;
    const tooltipContent = `${suggestedNameLine}      ${sourceLine}      ${pageLine}`;
    return tooltipContent;
  }
  openSettings(){
    const dialogRef = this.dialog.open(RigSettingsComponent, {
      width: '650px',
      data: ''
    });
  }
  openDocument(documentDetails: GetDocumentDto) {
    this.rigService.getDocument(documentDetails).subscribe((documentBlob: Blob) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const arrayBuffer = reader.result as ArrayBuffer;
        const uint8Array = new Uint8Array(arrayBuffer);
        const chunkSize = 1024;
        let binaryString = '';
        for (let i = 0; i < uint8Array.length; i += chunkSize) {
          const chunk = uint8Array.subarray(i, i + chunkSize);
          binaryString += String.fromCharCode.apply(null, Array.from(chunk));
        }
        const base64 = btoa(binaryString);
        const fileExtension = documentDetails.documentName.toLowerCase().split('.').pop();
        let contentType = 'application/pdf';
        this.showPdf = true;
        this.pdfContent = `data:${contentType};base64,${base64}`;
      };
      reader.readAsArrayBuffer(documentBlob);
    });
    this.selectLeftTabIndex = 1;
    this.isDescriptionView = false;
    this.isDocumentView = true;
  }
  afterLoadComplete(pdfData: any) {
    this.totalPages = pdfData.numPages;
    this.isLoaded = true;
  }
  nextPage() {
    this.page++;
  }
  prevPage() {
    this.page--;
  }
  onPageChanged(event: any) {
    this.page = event.page;
  }
  zoomIn() {
    this.zoomLevel += 0.1;
  }
  zoomOut() {
    this.zoomLevel -= 0.1;
  }
}
